<template>
    <main-content>
        <fraud-event-report-filter :action="filterAction"></fraud-event-report-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable">
        </kt-datatable>
    </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import FraudEventReportFilter from "@/views/Fraud-event/components/fraud-event-report-filter.vue";
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "./datatable/columns";

export default {
    name: "Get",
    components: {FraudEventReportFilter, mainContent},
    data() {
        return {
            query: {},
            apiUrl: this.getApiUrl(), 
        }
    },

    computed: {
        datatableProps() {
            return {
                id: 'fraud-event',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.apiUrl,
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },

                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns
            }
        },
        tab() {
            return this.$route.params.tab ===  "starshop" ? "starshop" : "pardakhtyari" 
        }
    },

    watch: {
        tab() {
            this.apiUrl = this.getApiUrl(); 
            this.reloadDatatable(); 
        }
    },

    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        
        getApiUrl() {
            return this.tab === "starshop" 
                ? ApiUrl.starshopPath('transaction/fraud-events') 
                : ApiUrl.path('transaction/fraud-events');
        },

        reloadDatatable() {
            if (this.$refs.datatable) {
                this.$refs.datatable.reload();
            }
        },
    }
}
</script>

<style scoped>

</style>
